import React, { useState, useEffect } from "react";
import { useSignal, useSlot } from 'react-signal-slot'
import PopupLoadPictures from "./../../../Common/PopupLoadPictures/PopupLoadPictures";
import Fetcher from "../../../Common/Fetch";
import { DocumentTypes } from "../../../enums/DocumentTypes"
import Tooltip from "../../../Ui/Tooltip";
import PictureCropPopup from "../../../Popups/PictureCropPopup";
import UploadFilePopup from "../../../Popups/UploadFilePopup";

interface IPropsType {
    lotId: number,
    CurrentCompanyId: number
}

function DepositLot(props: IPropsType) {

    const [step, setStep] = useState(0);
    const [error, setError] = useState('');
    const [isShowButtons, setIsShow] = useState(true);
    const [text, setText] = useState('');

    //метод для формирование платёжки задатка
    const GetBillMakingDepositPdf = async (companyId, lotId) => {
        const url = new URL('/Profile/GetBillMakingDepositPdf', window.location.origin);
        url.searchParams.append('companyId', companyId);
        url.searchParams.append('lotId', lotId);
        window.open(url.toString(), '_blank');
    }

    const openPopup = useSignal();
    const setTitle = useSignal();
    //Получение данных файла
    const getFile = async (file) => {
        let exFile;

        if (file instanceof File) {
            exFile = file; // Если это одиночный File
        } else if (file instanceof FileList) {
            exFile = file[0]; // Берём первый файл из FileList
        } else if (Array.isArray(file) && file.length > 0) {
            exFile = file[0]; 
            if (!(exFile instanceof File)) {
                console.error("First element of array is not a File:", exFile);
                setError("Ошибка: неверный формат файла");
                return;
            }
        } else {
            console.error("Invalid file input:", file);
            setError("Ошибка: файл не передан");
            return;
        }

        // Проверка валидности файла
        if (!exFile || !exFile.name) {
            console.error("File is invalid or has no name:", exFile);
            setError("Ошибка: файл не содержит имени");
            return;
        }

        console.log("exFile details:", {
            name: exFile.name,
            type: exFile.type,
            size: exFile.size,
            path: exFile.path
        });

        const formData = new FormData();
        formData.append("Comment", `Документ об оплате задатка для лота ${props.lotId}`);
        formData.append("Title", `Документ об оплате задатка для лота ${props.lotId}`);
        formData.append("DocumentFile", exFile); 
        formData.append("DocumentTypeId", Number(DocumentTypes.PaymentDocument).toString());
        formData.append("LotId", props.lotId.toString());
        formData.append("FileExtension", ".png,.jpg,.jpeg,.pdf,.docx,.odt");

        try {
            const response = await Fetcher("/DocumentApi/AddDocument?isChecksFolder=true", {
                method: "POST",
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setIsShow(false);
                setText("Ваш чек отправлен. Ожидайте подтверждения платежа.");
                console.log("Результат загрузки документа", data);
            } else {
                console.error("Статус не ok", response.statusText);
                setError("Ошибка при загрузке документа");
            }
        } catch (error) {
            console.error("Ошибка", error);
            setError("Произошла ошибка при загрузке файла");
        }
    };

    useEffect(() => {
        console.log("error", error);
    }, [error])

    return (
        <React.Fragment>
            <span>{text}</span>
            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {isShowButtons && 
                    <React.Fragment>
                        <button className="defaultPinkButton" onClick={() => { setStep(1) }}>Внести задаток</button>
                        <UploadFilePopup
                            head={{ title: "Документ о подтверждении задатка" }}
                            getFile={getFile}
                        >
                            <Tooltip text="Эта кнопка, с помощью которой можно добавить чек об оплате задатка. После подтверждения оплаты - будут возможны дальнейшие действия в зависимости от статуса торга." side="left">
                                <button>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 15 19" fill="none">
                                        <g clip-path="url(#clip0_3590_15630)">
                                            <path d="M1 3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H8.00589C8.37277 1 8.55622 1 8.72885 1.04145C8.8819 1.07819 9.02822 1.1388 9.16243 1.22104C9.3138 1.3138 9.44352 1.44352 9.70294 1.70294L13.2971 5.29706C13.5565 5.55648 13.6862 5.6862 13.779 5.83757C13.8612 5.97178 13.9218 6.1181 13.9586 6.27115C14 6.44378 14 6.62723 14 6.99411V15.6C14 16.4401 14 16.8601 13.8365 17.181C13.6927 17.4632 13.4632 17.6927 13.181 17.8365C12.8601 18 12.4401 18 11.6 18H3.4C2.55992 18 2.13988 18 1.81901 17.8365C1.53677 17.6927 1.3073 17.4632 1.16349 17.181C1 16.8601 1 16.4401 1 15.6V3.4Z" stroke="#170021" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 2C2.67157 2 2 2.67157 2 3.5V15.5C2 16.3284 2.67157 17 3.5 17H11.5C12.3284 17 13 16.3284 13 15.5V7.01476C13 6.62781 12.8505 6.25583 12.5826 5.97654L9.21207 2.46178C8.92917 2.16678 8.53815 2 8.12943 2H3.5ZM4 9.5C3.72386 9.5 3.5 9.72386 3.5 10C3.5 10.2761 3.72386 10.5 4 10.5H11C11.2761 10.5 11.5 10.2761 11.5 10C11.5 9.72386 11.2761 9.5 11 9.5H4ZM4 12.5C3.72386 12.5 3.5 12.7239 3.5 13C3.5 13.2761 3.72386 13.5 4 13.5H8C8.27614 13.5 8.5 13.2761 8.5 13C8.5 12.7239 8.27614 12.5 8 12.5H4Z" fill="url(#paint0_linear_3590_15630)" />
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3590_15630" x1="-3.71154" y1="2" x2="14.6544" y2="12.1942" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#0F0098" />
                                                <stop offset="0.629534" stop-color="#B200FF" />
                                                <stop offset="1" stop-color="#FF00F5" />
                                            </linearGradient>
                                            <clipPath id="clip0_3590_15630">
                                                <rect width="40" height="50" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </Tooltip>
                        </UploadFilePopup>
                        
                    </React.Fragment>
                }
            </span>
            {/* popup для получение квитанции на оплату задатка */}
            <div className="defaultPopupWrapper depositLot" style={{ display: step > 0 ? 'flex' : 'none' }}>
                {step == 1 &&
                    <div className="defaultPopup">
                        <button className="closePopupButton" onClick={() => { setStep(0) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M0.424745 0.15132C0.106868 0.347042 -0.0479959 0.714022 0.0253604 1.11362C0.0742647 1.38274 0.441047 1.79049 2.86181 4.21255L5.6412 7.00975L2.86181 9.79878C0.408444 12.2616 0.0742647 12.6368 0.0172097 12.914C-0.105051 13.5746 0.441046 14.1047 1.11756 13.9823C1.37023 13.9334 1.83482 13.5093 4.20667 11.1444L6.99422 8.36349L9.78991 11.1444C12.1536 13.5093 12.6182 13.9334 12.8709 13.9823C13.5474 14.1047 14.0935 13.5746 13.9712 12.914C13.9142 12.6368 13.58 12.2616 11.1266 9.79878L8.34723 7.00975L11.1266 4.21255C14.1668 1.16255 14.1587 1.17886 13.8897 0.53461C13.8001 0.322577 13.6778 0.200251 13.4659 0.110544C12.822 -0.158573 12.8383 -0.166728 9.80621 2.85881C8.28203 4.37565 7.01052 5.62338 6.97791 5.62338C6.95346 5.62338 5.69825 4.39196 4.19037 2.89143C2.67434 1.38274 1.35393 0.1187 1.23982 0.0779247C0.930089 -0.0444021 0.71002 -0.0199366 0.424745 0.15132Z" fill="#690097" />
                            </svg>
                        </button>
                        <div className="popupTitle">
                            <h4>Внимание! <hr /> </h4>
                        </div>
                        <p className="defaultPopupDescription">Для участия в данном аукционе необходимо внести задаток. Сформировать платёжное поручение?</p>
                        <button className="defaultPinkButton"
                            onClick={() =>
                            {
                                GetBillMakingDepositPdf(props.CurrentCompanyId, props.lotId)
                            }}
                        >
                            Сформировать
                        </button>
                    </div>
                }
            </div>
        </React.Fragment>
    )
}


export default DepositLot;

